import gql from 'graphql-tag';

export default gql`
  query getWorkflowsByChannel($channelId: UUID!) {
    getWorkflowsByChannel(channelId: $channelId) {
      _id
      _created
      _updated
      _createdBy
      _updatedBy
      _order
      event
      name
      when
      whenContext
      inStatus
      time
      action
      target
      targetType
      payload
      workflow
      dataValidationSchema
      type
      channelId
      deletedAt
      groupRole
    }
  }
`;
